import { render, staticRenderFns } from "./SuccessErrorMessage.vue?vue&type=template&id=4ddce882&"
import script from "./SuccessErrorMessage.vue?vue&type=script&lang=js&"
export * from "./SuccessErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports